<template>
  <div>
    <dara-form v-if="questionEditVm.question" :submit="save">
      <div>
        <label for="anonymous" class="w-100 mb-2 mt--xl">{{ $t('want-to-ask-an-anonymous-question') }}</label>
        <div class="form-check form-check-inline">
          <label class="form-check-label">
            <input
              id="showOption"
              v-model="questionEditVm.question.anonymous"
              type="radio"
              class="form-check-input"
              name="optionsRadios"
              :value="false">
            {{ $t('no') }}
          </label>
        </div>
        <div class="form-check form-check-inline">
          <label class="form-check-label">
            <input
              id="hideOption"
              v-model="questionEditVm.question.anonymous"
              type="radio"
              class="form-check-input"
              name="optionsRadios"
              :value="true">
            {{ $t('yes') }}
          </label>
        </div>
      </div>

      <div class="form-field mt-4">
        <dara-input
          v-model="questionEditVm.question.title"
          :label="$t('title') + '*'"
          :name="$t('title-field')"
          type="text"
          rules="required|min:2"
          :placeholder="$t('question-title-placeholder')" />
      </div>
      <div class="form-field">
        <dara-textarea
          v-model="questionEditVm.question.content"
          :label="$t('content') + '*'"
          :name="$t('content-field')"
          type="text"
          rules="required"
          :placeholder="$t('question-description-placeholder')" />
      </div>

      <dara-row class="align-items-center">
        <dara-col :xs="24" :span="12" justify="left">
          {{ $t('access') }}*
          <dara-select
            v-bind="$attrs"
            :name="$t('access-field')"
            rules="required"
            :value="questionEditVm.question.access"
            class="mt-1 mb-0"
            @on-change="onAccessChange">
            <option :value="null" disabled>{{ $t('select-access') }}</option>
            <option
              v-for="access in all_access"
              :key="access.name"
              :value="access.value">
              {{ access.name }}
            </option>
          </dara-select>
          <small class="text-muted dara-u-text--small d-block mt-1 mb-3">
            {{ $t(accessesInfo[questionEditVm.question.access]) }}
          </small>
        </dara-col>
        <dara-col :xs="24" :span="12">
          <dara-department-chooser
            ref="departmentChooser"
            v-model="questionEditVm.question.department_id"
            @on-change="onDepartmentChange"
            @onNewDepartment="onNewDepartment" />
        </dara-col>
      </dara-row>

      <div class="mt-4 mb-3 d--flex justify-content-end">
        <dara-button
          class="btn btn-secondary"
          width="110"
          size="sm"
          @click="goHistoryBack()">
          {{ $t('cancel') }}
        </dara-button>
        <dara-button
          native-type="submit"
          class="btn btn-success ms-2"
          width="110"
          size="sm">
          <a v-if="questionEditVm.question.id">{{ $t('update') }}</a>
          <a v-else>{{ $t('save') }}</a>
        </dara-button>
      </div>
    </dara-form>

    <dara-modal-new-department
      v-if="showModal()"
      ref="departmentModal"
      @close="closeModal()">
    </dara-modal-new-department>
  </div>
</template>

<script>
import { goHistoryBack } from '@/router/route.service';
import { QUESTION_ACCESS_INFO } from '@/modules/question/question.constants';
import { translate } from '@/services/translate.service';

import DaraDepartmentChooser from '@/modules/department/components/DepartmentChooser.vue';

export default {
  name: 'DaraQuestionEdit',
  components: {
    DaraDepartmentChooser,
  },
  inject: ['questionEditVm'],
  data() {
    return {
      all_access: [
        { name: translate('public'), value: 0 },
        { name: translate('department-only'), value: 1 },
      ],
      newDepartment: false,
      accessesInfo: QUESTION_ACCESS_INFO,
    };
  },
  methods: {
    goHistoryBack,
    save() {
      this.$emit('save', this.questionEditVm.question.department_id, this.questionEditVm.question.access);
    },
    onDepartmentChange(department) {
      this.$set(this.questionEditVm.question, 'department_id', department.id);
    },
    onAccessChange(access) {
      this.$set(this.questionEditVm.question, 'access', access);
    },
    onNewDepartment() {
      this.newDepartment = true;
    },
    showModal() {
      return this.newDepartment;
    },
    closeModal() {
      this.$refs.departmentChooser.onfetch();
      this.newDepartment = false;
    },
  },
};
</script>
